import { Table } from "antd";
import React, { useState } from "react";
import uuidv4 from "uuid/v4";
import "./style.css";

const TableComplex = props => {
  const { columns, dataSource, rowClassName, showHoverEffect, summary, pagination=false, loading=false, showHeader=true, rowSelection=null, additionalClass="", selectedRowKeys = null } = props;
  const [hasSearch, setHasSearch] = useState(false);

  let expandable = props.expandable || {};
  /* expandable.expandedRowClassName = () => {
    return (
      "ts-vapor-tableComplex-expandable-row " +
      (expandable ? expandable.expandedRowClassName : "")
    );
  };*/

  const convColumns = () => {
    let cols = [];
    if (columns) {
      columns.map(col => {
        if (col.search) {
          setHasSearch(true);
        }
        if (!col.personalTitle) {
          if (col){
            col.title = (
              <div className={"ts-vapor-tableComplex-thCol" + (hasSearch ? " thCol-with-Search" : "")}>
                <div
                  className={
                    "ts-vapor-tableComplex-thCol-text " +
                (col.headerAlign || "left")
                  }
                >
                  {col.title || <span>&nbsp;</span>}
                </div>
                {hasSearch && <div>&nbsp;</div>}
              </div>
            );
          }
        }
        return cols.push(col);
      });
    }
    return cols;
  };

  let additionalClassname = additionalClass;
  if (!showHoverEffect) {
    additionalClassname += " noHover";
  }

  const renderSummary = () => {
    let items = [];
    if (summary && typeof summary === "object") {
      summary.map(it => {
        return items.push(<Table.Summary.Cell key={uuidv4()}>{it}</Table.Summary.Cell>);
      });
    }
    if (items.length === 0) {
      return null;
    }
    return <Table.Summary.Row>{items}</Table.Summary.Row>;
  };
  
  return (
    <Table
      {...props}
      rowKey={record => {
        return record?.conto?.uuid || record?.key || record?.id;
      }}
      className={"ts-vapor-tableComplex" + additionalClassname}
      rowClassName={(record, index) => { return `ts-vapor-tableComplex-row row_${record?.conto?.uuid} ` + (rowClassName ? rowClassName(record, index) : ""); }}
      columns={convColumns()}
      dataSource={dataSource}
      pagination={pagination}
      summary={() => renderSummary()}
      expandable={expandable}
      loading={loading}
      showHeader={showHeader}
      rowSelection={rowSelection}
      selectedRowKeys={selectedRowKeys}
    />
  );
};

export default TableComplex;
